import { useMutation } from '@apollo/react-hooks';
import {
  removeGroupMutation,
  removeGroupMemberMutation,
  addMultipleNodesToGroup,
} from 'services/apollo/mutations';
import produce from 'immer';
import { Logger, GroupListQuery } from 'services';

export function useRemoveGroupMutation(id: any) {
  return useMutation(removeGroupMutation, {
    variables: {
      id,
    },
    update(cache, { data }) {
      const readQueryResult: any = cache.readQuery({
        query: GroupListQuery,
      });

      try {
        cache.writeQuery({
          query: GroupListQuery,
          data: produce(readQueryResult, (draft: any) => {
            const index = draft.me.groups.findIndex((group: any) => group.id === id);
            if (index !== -1) draft.me.groups.splice(index, 1);
          }),
        });
      } catch (err) {
        Logger.log(err);
      }

      if (data?.removeGroup?.error) {
        cache.writeQuery({
          query: GroupListQuery,
          data: produce(readQueryResult, (draft: any) => {
            draft.me.groups = data?.removeGroup?.groups;
          }),
        });
      }
    },
  });
}

export function useRemoveGroupMemberMutation(id: any, personId: any, isAdmin: boolean) {
  return useMutation(removeGroupMemberMutation, {
    variables: {
      id,
      personId,
    },
    update(cache, { data }) {
      const readQueryResult: any = cache.readQuery({
        query: GroupListQuery,
      });

      if (isAdmin) {
        try {
          cache.writeQuery({
            query: GroupListQuery,
            data: produce(readQueryResult, (draft: any) => {
              const groupIndex = draft.me.groups.findIndex((group: any) => group.id === id);
              const memberIndex = draft.me.groups[groupIndex].members.findIndex(
                (member: any) => member.id === personId
              );
              if (memberIndex !== -1) draft.me.groups[groupIndex].members.splice(memberIndex, 1);
            }),
          });
        } catch (err) {
          Logger.log(err);
        }
      } else {
        try {
          cache.writeQuery({
            query: GroupListQuery,
            data: produce(readQueryResult, (draft: any) => {
              const index = draft.me.groups.findIndex((group: any) => group.id === id);
              if (index !== -1) draft.me.groups.splice(index, 1);
            }),
          });
        } catch (err) {
          Logger.log(err);
        }
      }

      if (data?.removeGroupMember?.error) {
        cache.writeQuery({
          query: GroupListQuery,
          data: produce(readQueryResult, (draft: any) => {
            draft.me.groups = data?.removeGroupMember?.groups;
          }),
        });
      }
    },
  });
}

export function useAddMultipleNodesToGroup(ids: string[], targetId: string) {
  return useMutation(addMultipleNodesToGroup, {
    variables: {
      ids,
      targetId,
    },
  });
}
